import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Imprint from './pages/Imprint';
import Privacy from './pages/Privacy';
import Resources from './pages/Resources';
import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';
import Telemetry from './pages/Telemetry';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="resources" element={<Resources />} />
          <Route path="blog" element={<BlogIndex />} />
          <Route path="blog/:slug" element={<BlogPost />} />
          <Route path="imprint" element={<Imprint />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="telemetry" element={<Telemetry />} />
          {/* Catch-all route redirects to Home */}
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;